import { render, staticRenderFns } from "./PostableEquipmentEdit.vue?vue&type=template&id=ba230a08&scoped=true"
import script from "./PostableEquipmentEdit.vue?vue&type=script&lang=js"
export * from "./PostableEquipmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba230a08",
  null
  
)

export default component.exports